import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { CategoryPage } from './pages/Category';
import { ProductPage } from './pages/Product';
import { WholesaleApply } from './pages/WholesaleApply';
import { Contact } from './pages/Contact';
import { Products } from './pages/Products';
import { WhyTierOne } from './pages/WhyTierOne';
import { HowItWorks } from './pages/HowItWorks';
import { ProductionSupport } from './pages/ProductionSupport';
import { DealerSupport } from './pages/DealerSupport';
import { PrivateLabel } from './pages/PrivateLabel';
import { CombinedPricing } from './pages/CombinedPricing';
import { Login } from './pages/Login';
import { SamplesSize } from './pages/SamplesSize';
import { SamplesProduct } from './pages/SamplesProduct';
import { OrderSupport } from './pages/OrderSupport';
import { DesignPolicy } from './pages/DesignPolicy';
import { Returns } from './pages/Returns';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="category/:slug" element={<CategoryPage data-id="element-7" />} data-id="element-6" />
          <Route path="product/:sku" element={<ProductPage data-id="element-9" />} data-id="element-8" />
          <Route path="wholesale-apply" element={<WholesaleApply data-id="element-11" />} data-id="element-10" />
          <Route path="contact" element={<Contact data-id="element-13" />} data-id="element-12" />

          {/* Content routes for links in nav and footer */}
          <Route path="products" element={<Products data-id="element-15" />} data-id="element-14" />
          <Route path="why-tier-one" element={<WhyTierOne data-id="element-17" />} data-id="element-16" />
          <Route path="how-it-works" element={<HowItWorks data-id="element-19" />} data-id="element-18" />
          <Route path="production-support" element={<ProductionSupport data-id="element-21" />} data-id="element-20" />
          <Route path="dealer-support" element={<DealerSupport data-id="element-23" />} data-id="element-22" />
          <Route path="private-label" element={<PrivateLabel data-id="element-25" />} data-id="element-24" />
          <Route path="combined-pricing" element={<CombinedPricing data-id="element-27" />} data-id="element-26" />
          <Route path="login" element={<Login data-id="element-29" />} data-id="element-28" />
          <Route path="samples/size" element={<SamplesSize data-id="element-31" />} data-id="element-30" />
          <Route path="samples/product" element={<SamplesProduct data-id="element-33" />} data-id="element-32" />
          <Route path="order-support" element={<OrderSupport data-id="element-35" />} data-id="element-34" />
          <Route path="design-policy" element={<DesignPolicy data-id="element-37" />} data-id="element-36" />
          <Route path="returns" element={<Returns data-id="element-39" />} data-id="element-38" />
          <Route path="privacy" element={<Privacy data-id="element-41" />} data-id="element-40" />
          <Route path="terms" element={<Terms data-id="element-43" />} data-id="element-42" />

          {/* Catch-all 404 */}
          <Route path="*" element={<NotFound data-id="element-45" />} data-id="element-44" />
        </Route>
      </Routes>
    </BrowserRouter>;
}